<template>
  <div class="users">
    <ut-form inline>
      <ut-form-item label="账号">
        <ut-input v-model="form.account"></ut-input>
      </ut-form-item>
      <ut-form-item>
        <ut-button type="primary" @click="search">查询</ut-button>
      </ut-form-item>
    </ut-form>

    <ut-table :source="dataSource" border>
      <ut-table-column title="账号" index="premiumRuleId" min-width="100" />

      <ut-table-column fixed='right' title="操作" align="center"
                       inline-template width="140">
        <template>
          <ut-button type='primary' size="small" @click="permisMove(row)">权限转移</ut-button>
        </template>

      </ut-table-column>
    </ut-table>

    <ut-pagination style="margin: 10px 0;"
                   show-size-changer
                   :page-sizes='[20,50,100,150,200]'
                   :total='page.total'
                   :current='page.page'
                   :page-size='page.pageSize'
                   @size-change='sizeChange'
                   @change='changePager' />

    <ut-modal v-model='modal.visible' title='权限转移'>
      <ut-form :label-width="100">
        <ut-form-item label="转交人">
          {{modal.key1}}
        </ut-form-item>
        <ut-form-item>
          <template slot='label'><span style='color:red'>* </span> 接收人</template>
          <ut-select v-model='modal.key1'
                     placeholder="选择角色" clearable>
            <ut-option v-for='(v,k) in opt'
                       :key="k"
                       :value="k"
                       :label='v.name'>
            </ut-option>
          </ut-select>
        </ut-form-item>
        <ut-form-item>
          <template slot='label'><span style='color:red'>* </span> 转交策略</template>
          <ut-radio-group v-model="retainFrom">
            <ut-radio-button value="true">保留</ut-radio-button>
            <ut-radio-button value="false">删除</ut-radio-button>
          </ut-radio-group>
          <ut-alert type='warn' size="small">
            选择删除，转交成功后转交人权限会被清空，默认保留
          </ut-alert>
        </ut-form-item>

      </ut-form>
      <div slot='footer'>
        <ut-button type='danger' style="margin-right:10px;"
                   @click='modal.visible=false'>取消</ut-button>
        <ut-button type='success' @click="submit">确认</ut-button>
      </div>
    </ut-modal>

  </div>
</template>

<script>
export default {

  data () {
    return {
      form: {
        account: ''
      },
      dataSource: [
        { id: 1 }
      ],
      page: {
        total: 0,
        current: 1,
        pageSize: 20
      },
      modal: {
        visible: false,
        rowId: '',
        key1: '',

        form: {
          roleId: '',
          userName: '',
          name: ''
        }
      }
    }
  },
  methods: {
    search () {
      const params = {
        ...this.form
      }
      const url = `/adxBss/AdxUserRole/list/${this.page.pageSize}/${this.page.current}`
      this.$http.get(url, { params })
        .then(({ data }) => {
          if (+data.code === 1) {
            this.page.total = data.data.total
            this.dataSource = Object.freeze(data.data.list)
          } else {
            throw data.message
          }
        }).catch((err = '') => {
          this.$message.error(err)
        })
    },

    changePager (val) {
      this.page.current = val
      this.$nextTick(this.search)
    },
    sizeChange (size) {
      this.page.pageSize = size
      if (this.page.current === 1) {
        this.$nextTick(this.search)
      }
    },

    permisMove (row) {
      this.modal.key1 = row.id
      this.modal.visible = true
    },
    submit () {
      this.modal.visible = false
    },

    filter (val) {
      const data = []
      const inp = val && val.toLowerCase()
      this.selectedUser.map(item => {
        if (item.name.includes(inp) || item.id.toLowerCase().includes(inp)) {
          data.push(item)
        }
      })
      if (data.length) {
        this.selectedSearchUsers = data
      } else {
        this.selectedSearchUsers = null
      }
    }

  }

}
</script>

<style lang="less" scoped>
.users {
  padding: 16px;
}
</style>
